import React, { useMemo } from 'react';
import { ISelectOption } from 'components/Select/types';
import { TTypeOfSchedule, TTypeOfReport } from 'types';
import { scheduleType, availableScheduleTypesForFeesReport } from 'appConstants';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { useTranslation } from 'react-i18next';
import style from './ScheduleTypesMultipleSelect.module.scss';

interface IScheduleTypesMultipleSelect {
	setIDsScheduleTypes: (value: TTypeOfSchedule[]) => void;
	IDReportType: null | TTypeOfReport;
}

const ScheduleTypesMultipleSelect: React.FC<IScheduleTypesMultipleSelect> = ({ setIDsScheduleTypes, IDReportType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectScheduleType') }], [t]);
	const mappedOptions = useMemo<ISelectOption[]>(() => {
		const availableScheduleTypes =
			IDReportType === 'Fees'
				? scheduleType.filter((el) => availableScheduleTypesForFeesReport.includes(el.scheduleTypeID))
				: scheduleType;

		return availableScheduleTypes.map((el) => ({
			id: el.scheduleTypeID,
			name: tForm(el.scheduleTypeName),
		}));
	}, [IDReportType, tForm]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="ScheduleTypesMultipleSelect"
			name="IDsScheduleTypes"
			label="scheduleTypeLabel"
			options={mappedOptions}
			onChange={setIDsScheduleTypes}
			validationRules={validationRules}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(ScheduleTypesMultipleSelect);
